import React, { useEffect } from "react";
import { isProctoringEnabled } from "../../utils/proctoring";

const Complete = () => {
  const proctored = isProctoringEnabled();

  useEffect(() => {
    const timer = setTimeout(() => {
      const returnUrl =
        localStorage.getItem("LANGUAGE_TEST_RETURN_URL") ||
        "https://www.gappeo.ai/";

      window.location.href = returnUrl;
    }, 500);

    return () => clearTimeout(timer);
  }, [])

  return (
    <div className={`language-container${proctored ? "" : " lt-responsive"}`}>
      <div className="language-test-section d-flex">
        <div className="language-left-section" style={{width:'100%'}}>
          <img src="/images/gappeo-logo.svg" alt="" width={86} height={71} />
          <div className="question-text">
            <h2>🎉 Completed</h2>
            <p>Your exam session has been completed. Thanks — you'll be redirected shortly.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Complete;